export default __webpack_public_path__ + "static/media/yes-icon.61b98101.svg";